import dayjs, { Dayjs } from 'dayjs';

import { intlLocale } from 'utils/intl';

export function secondsToDayjs(seconds: number): Dayjs {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  // Create a dayjs object with today's date but set the time to the duration
  return dayjs().hour(hours).minute(minutes).second(0).millisecond(0);
}

export function dayjsToSeconds(dayjsObj: Dayjs): number {
  const hours = dayjsObj.hour();
  const minutes = dayjsObj.minute();

  return hours * 3600 + minutes * 60;
}

export function formatShortDate(timestamp: number, language: string): string {
  return new Intl.DateTimeFormat(intlLocale(language), { day: 'numeric', month: 'short' }).format(
    timestamp
  );
}
